import api from '@api/api';
import { UNDECIDED_CODE_LIST } from '@common/constants';
import { getApiErrorMessage } from '@common/utils';
import { showAlert, SHOW_MODAL } from '@store/actions/commonAction';
import * as actions from '@store/actions/planListAction';
import {
  changeDelSearchParam,
  changeDelSearchPayload,
} from '@store/actions/planListAction';
import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';

// 설계목록 조회
function* searchPlanList() {
  const { searchParam, planList, pageConditionKey, pageCount, pageNextYn } =
    yield select(state => state.planListReducer);
  const paramsData = {
    ...searchParam,
    pageIndex: 1,
  };
  const payloadData = {
    searchName: searchParam.custNo === '' ? searchParam.searchName : '',
    searchDateYn: 'N',
    pageConditionKey: '',
    pageNextYn: '',
    pageCount: 10,
  };

  const response = yield call(api.searchPlanList, {
    params: paramsData,
    payload: payloadData,
  });
  const { status, data } = response;
  if (status === 200) {
    yield put({
      type: actions.SEARCH_PLAN_LIST_SUCCESS,
      payload: data,
    });
  } else {
    const errorMessage = getApiErrorMessage(response);

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 설계목록 삭제
function* deletePlanList() {
  const { planList } = yield select(state => state.planListReducer);
  const payloadData = {
    seq: [],
  };
  let ds_list = []; //KB 설계목록 삭제

  planList.forEach(function (data) {
    if (data.isChecked) {
      if (data.planEstablishNo !== null) {
        payloadData.seq.push(data.planEstablishNo);
      } else {
        data.dcPrpsListVO.chkFlag = '1';
        ds_list.push(data.dcPrpsListVO);
      }
    }
  });

  let status = -1;
  if (payloadData.seq.length > 0) {
    const res = yield call(api.deletePlanList, {
      params: {},
      payload: payloadData,
    });
    status = res.status;

    if (status !== 200) {
      const errorMessage = getApiErrorMessage(res);

      yield put({
        type: SHOW_MODAL,
        payload: {
          visible: true,
          type: 'info',
          msg: errorMessage,
        },
      });
    }
  }

  if (status === 200) {
    yield put({
      type: actions.SEARCH_PLAN_LIST,
    });
  }
}

// 삭제목록 조회
function* searchDeletePlanList() {
  const { delSearchParam, pageConditionKey, pageCount, pageNextYn } =
    yield select(state => state.planListReducer);
  const paramsData = {
    ...delSearchParam,
    delType: 'Y',
    favoriteType: 'ALL',
    excuteFinancial: 'ALL',
    compCd: 'ALL',
    pageIndex: 1,
  };
  const payloadData = {
    searchName: delSearchParam.custNo === '' ? delSearchParam.searchName : '',
    searchDateYn: 'N',
    pageConditionKey: '',
    pageNextYn: '',
    pageCount: 10,
  };

  const response = yield call(api.searchPlanList, {
    params: paramsData,
    payload: payloadData,
  });

  const { status, data } = response;
  if (status === 200) {
    yield put({
      type: actions.SEARCH_DELETE_PLAN_LIST_SUCCESS,
      payload: data,
    });

    const pagingResult = data?.pagingResult;
    yield put(
      changeDelSearchPayload({
        pageConditionKey: pagingResult.pageConditionKey,
        pageCount: pagingResult.pageCount,
        pageNextYn: pagingResult.pageNextYn,
        pageTotalCount: pagingResult.pageTotalCount,
      }),
    );
  } else {
    const errorMessage = getApiErrorMessage(response);

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 설계목록 조회 Scroll
function* infiniteSearchPlanList() {
  const {
    searchParam,
    planList,
    isLast,
    pageConditionKey,
    pageCount,
    pageNextYn,
    pageIndex,
  } = yield select(state => state.planListReducer);

  const paramsData = {
    ...searchParam,
    pageIndex: 1,
  };
  const payloadData = {
    searchName: searchParam.custNo === '' ? searchParam.searchName : '',
    searchDateYn: 'N',
    pageConditionKey: pageConditionKey,
    pageNextYn: pageNextYn,
    pageCount: 10,
  };

  if (pageNextYn !== 'N,N') {
    const response = yield call(api.searchPlanList, {
      params: paramsData,
      payload: payloadData,
    });
    const { status, data } = response;
    if (status === 200) {
      const newResults = [
        ...new Set(
          [...planList, ...data.pagingResult.list].map(JSON.stringify),
        ),
      ].map(JSON.parse);
      yield put({
        type: actions.INFINITE_SEARCH_PLAN_LIST_SUCCESS,
        payload: { ...data, results: newResults },
      });
    } else {
      const errorMessage = getApiErrorMessage(response);

      yield put({
        type: SHOW_MODAL,
        payload: {
          visible: true,
          type: 'info',
          msg: errorMessage,
        },
      });
    }
  }
}

// 삭제목록 조회 Scroll
function* infiniteSearchDelPlanList() {
  const {
    delSearchParam = {},
    delSearchPayload = {},
    delPlanList,
    delIsLast,
    pageConditionKey,
    pageNextYn,
    pageCount,
  } = yield select(state => state.planListReducer);

  const paramsData = {
    ...delSearchParam,
    delType: 'Y',
    favoriteType: 'ALL',
    excuteFinancial: 'ALL',
    searchDateYn: 'N',
    pageIndex: 1,
  };
  const payloadData = {
    searchName: delSearchParam.custNo === '' ? delSearchParam.searchName : '',
    searchDateYn: 'N',
    pageConditionKey: delSearchPayload.pageConditionKey,
    pageNextYn: delSearchPayload.pageNextYn,
    pageCount: 10,
  };
  const pageNext = delIsLast.split(',');
  const kbPageNext = pageNext[0];
  const pruPageNext = pageNext[1];

  if (kbPageNext === 'Y' || pruPageNext === 'Y') {
    const response = yield call(api.searchPlanList, {
      params: paramsData,
      payload: payloadData,
    });
    const { status, data } = response;
    if (status === 200) {
      yield put({
        type: actions.INFINITE_SEARCH_DEL_PLAN_LIST_SUCCESS,
        payload: data,
      });

      //삭제 하고 pageIndex 추가
      yield call(changeDelSearchParam, {
        ...delSearchParam,
        pageIndex: delSearchParam.pageIndex + 1,
      });

      const pagingResult = data?.pagingResult;
      yield put(
        changeDelSearchPayload({
          pageConditionKey: pagingResult.pageConditionKey,
          pageCount: pagingResult.pageCount,
          pageNextYn: pagingResult.pageNextYn,
          pageTotalCount: pagingResult.pageTotalCount,
        }),
      );
    } else {
      const errorMessage = getApiErrorMessage(response);

      yield put({
        type: SHOW_MODAL,
        payload: {
          visible: true,
          type: 'info',
          msg: errorMessage,
        },
      });
    }
  }
}

// 설계제목 저장
function* savePlan(action) {
  const { planEstablishNo, planEstablishTitle } = action.payload;
  const response = yield call(api.savePlan, {
    params: {},
    payload: {
      planEstablishNo: planEstablishNo,
      planEstablishTitle: planEstablishTitle,
    },
  });
  const { status } = response;
  if (status === 200) {
    yield put({
      type: actions.CHANGE_PLAN_TITLE,
      payload: {
        planEstablishNo: planEstablishNo,
        planEstablishTitle: planEstablishTitle,
      },
    });
  } else {
    const errorMessage = getApiErrorMessage(response);

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 재정안정계획서비교
function* planFinancialCompare({ payload }) {
  const response = yield call(api.planFinancialCompare, {
    params: {},
    payload: { targetPlanEstablishNo: payload.targetPlanEstablishNo },
  });
  const { status, data } = response;
  if (status === 200) {
    yield put({
      type: actions.PLAN_FINANCIAL_COMPARE_SUCCESS,
      payload: data,
    });

    if (data.reportInfo.length > 0) {
      const statusPlan = data.reportInfo.filter(
        data => data.planEstablishDocStatus === 'R',
      );
      if (statusPlan.length > 0) {
        payload.callback('R');
      } else {
        payload.callback('C');
      }
    } else {
      yield put(
        showAlert({
          message:
            '비교 리포트가 발행되지 않았습니다.\n다음에 다시 시도해주세요.',
        }),
      );
    }
  } else {
    const errorMessage = getApiErrorMessage(response);

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 오늘 환율 조회
function* searchExchangeRate({ payload }) {
  const response = yield call(api.searchExchangeUsd, {
    params: { effectiveDate: payload.effectiveDate, premium: payload.premium },
    payload: {},
  });
  const { status, data } = response;
  if (status === 200) {
    yield put({
      type: 'SEARCH_EXCHANGE_RATE_SUCCESS',
      payload: data,
    });
    if (payload.callback) {
      payload.callback(data);
    }
  } else {
    const errorMessage = getApiErrorMessage(response);

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 변액상품 정보 조회
function* searchSuitability({ payload }) {
  const response = yield call(api.searchSuitability, {
    params: { applicationNo: payload.applicationNo },
  });
  const { status, data } = response;
  if (status === 200) {
    yield put({ type: actions.SEARCH_SUITABILTY_SUCCESS, payload: data });
    if (payload.callback) payload.callback(true);
  } else {
    const errorMessage = getApiErrorMessage(response);
    yield put(showAlert({ message: errorMessage }));
  }
}

// 미결보완 값이 없는 경우 체크
function* checkOmniUndecidedEnable({ payload }) {
  const response = yield call(api.getCheckOmniUndecidedEnable, {
    params: {
      planEstablishNo: payload.planEstablishNo,
    },
  });

  const { status, data } = response;
  const historyDetailList =
    data.data?.detail?.map(obj => obj.undecidedCode) ?? []; // 미결 이력 리스트

  if (status === 200) {
    const response = yield call(api.getUndecidedDocList, {
      params: {
        applicationNo: payload.applicationNo,
      },
    });
    const { status, data } = response;

    if (status === 200) {
      const checkList = data?.data ?? []; // 부분 재발행시 체크 리스트
      const noDataDocList = UNDECIDED_CODE_LIST.filter(obj =>
        checkList.includes(obj.docType),
      ).filter(obj => !historyDetailList.includes(obj.code)); // 데이터 없는 보완 문서 리스트

      if (payload.callback)
        payload.callback(true, noDataDocList ?? [], checkList);
    } else {
      const errorMessage = getApiErrorMessage(response);

      yield put({
        type: SHOW_MODAL,
        payload: {
          visible: true,
          type: 'info',
          msg: errorMessage,
        },
      });
    }
  } else {
    if (payload.callback) payload.callback(false);
  }
}

// 청약진행불가 체크
function* checkSubscription({ payload }) {
  const response = yield call(api.checkSubscription, {
    params: { planEstablishNo: payload.plan.planEstablishNo },
  });
  const { skipEaAvailableYn } = yield select(state => state.planReducer);

  const { status, data } = response;
  if (status === 200) {
    if (payload.callback) {
      const rejectReasonStatus =
        skipEaAvailableYn === 'Y' ? 'OK' : data.rejectReasonStatus;
      payload.callback(payload.plan, rejectReasonStatus);
    }
  } else {
    const errorMessage = getApiErrorMessage(response);

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 옴니청약 가능 시간 체크
function* checkOmniTime({ payload }) {
  const response = yield call(api.checkOmniTime);
  const { status, data } = response;
  if (status === 200) {
    if (data.valid) {
      if (payload.callback) payload.callback();
    } else {
      yield put({
        type: SHOW_MODAL,
        payload: {
          visible: true,
          type: 'info',
          msg: data.msg,
        },
      });
    }
  } else {
    const errorMessage = getApiErrorMessage(response);

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

function* watchPlanList() {
  // 설계목록 검색
  yield takeLatest(actions.SEARCH_PLAN_LIST, searchPlanList);
  // 설계목록 삭제
  yield takeLatest(actions.DELETE_PLAN_LIST, deletePlanList);
  // 설계목록 삭제목록 조회
  yield takeLatest(actions.SEARCH_DELETE_PLAN_LIST, searchDeletePlanList);
  // InfiniteScroll
  yield takeLatest(actions.INFINITE_SEARCH_PLAN_LIST, infiniteSearchPlanList);
  // 삭제목록 scroll
  yield takeLatest(
    actions.INFINITE_SEARCH_DEL_PLAN_LIST,
    infiniteSearchDelPlanList,
  );
  yield takeLatest(actions.SAVE_PLAN, savePlan);
  yield takeLatest(actions.PLAN_FINANCIAL_COMPARE, planFinancialCompare);
  yield takeLatest(actions.SEARCH_EXCHANGE_RATE, searchExchangeRate);
  yield takeLatest(actions.SEARCH_SUITABILITY, searchSuitability);
  yield takeLatest(actions.CHECK_SUBSCRIPTION, checkSubscription);
  yield takeLatest(actions.CHECK_UNDECIDED_ENABLE, checkOmniUndecidedEnable);
  yield takeLatest(actions.CHECK_OMNI_TIME, checkOmniTime);
}

export default function* planListSaga() {
  yield all([fork(watchPlanList)]);
}
